module.exports = __webpack_public_path__ + "img/STOmicsDB.828902fa.png";